var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9871 33.3835L41.0401 21.6194C41.1695 20.1682 40.0265 18.9183 38.5696 18.9183C37.4233 18.9183 36.4265 19.7035 36.1588 20.8184L35.9878 21.5294C35.7886 22.2843 35.4343 24.127 35.4343 24.127C34.7323 24.2058 33.3744 24.3172 32.5036 24.3779C31.5778 24.4432 30.5056 24.4972 29.6821 24.5545C28.8586 24.6119 28.0363 24.9899 27.8911 25.9M32.5126 35.9789H37.9464M34.766 30.3719L34.6051 31.9402L31.6835 32.2507C30.3403 32.3812 29.3154 33.0337 29.0971 34.2205C28.6021 36.9127 27.6616 41.6917 27.1374 44.3287C27.0519 44.7595 27.2578 45.295 28.4671 45.295C29.2445 45.295 30.3988 44.6774 30.6024 43.927L31.9828 38.698M37.3243 35.9789L40.8106 35.971C41.8344 35.9688 42.6871 35.188 42.7805 34.1688L43.7266 23.8694M36.6976 27.5403L36.6886 27.5425C35.576 27.8542 34.4263 28.0128 33.2709 28.0128H11.6191M37.5538 36.0003V42.9562M14.2269 30.7049V42.8988M40.2358 45.2017H34.8729M15.7265 45.2017H12.7273M18.503 23.3497L18.0001 25.9M21.6631 23.3497L21.1603 25.9M40.9457 12.0465C41.8071 13.3807 41.4239 15.1606 40.0898 16.022C38.7556 16.8835 36.9757 16.5003 36.1143 15.1661C35.2528 13.832 35.636 12.0521 36.9702 11.1906C38.3043 10.3292 40.0842 10.7124 40.9457 12.0465ZM12.3819 12.0749H23.9908L26.3544 23.1955H14.7455L12.3819 12.0749Z",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylists);
export default __webpack_public_path__ + "static/media/playlists.7add3b817f5250615e3e9f36fad2b306.svg";
export { ForwardRef as ReactComponent };